import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';
import { Severity } from '@sentry/types';

@Injectable({
    providedIn: 'root'
})

export class DynamicScriptService {
    captchaCode = environment.captchaCode;
    loadBitpayScript(): Promise<any> {
        return new Promise((resolve, reject) => {
            const scriptElement = window.document.createElement('script');
            scriptElement.src = 'https://bitpay.com/bitpay.min.js';

            scriptElement.onload = () => {
                resolve('');
            };

            scriptElement.onerror = () => {
                reject(new Error('Failed to load BitPay script'));
            };

            window.document.body.appendChild(scriptElement);
        });
    }
    loadCaptchaScript(): Promise<boolean> {
        const existingScript = document.getElementById('recaptcha');
    
        if (existingScript) {
            return this.waitUntilGrecaptchaAvailable();
        }
    
        return new Promise((resolve) => {
            const scriptElement = window.document.createElement('script');
            scriptElement.id = 'recaptcha';
            scriptElement.src = `https://www.google.com/recaptcha/api.js?render=${this.captchaCode}`;
            scriptElement.async = true;
            scriptElement.defer = true;
    
            scriptElement.onload = () => {
                this.waitUntilGrecaptchaAvailable()
                    .then(resolve); // resolves true/false
            };
    
            scriptElement.onerror = () => {
                Sentry.captureMessage('reCAPTCHA script failed to load', {
                    level: Severity.Info,
                    tags: { service: 'recaptcha' }
                });
    
                resolve(false);
            };
    
            window.document.body.appendChild(scriptElement);
        });
    }

    private waitUntilGrecaptchaAvailable(): Promise<boolean> {
        return new Promise((resolve) => {
            const maxMs = 15000;
            const intervalMs = 50;
            const start = Date.now();
    
            const tick = () => {
                const grecaptcha = (window as any).grecaptcha;
    
                if (typeof grecaptcha !== 'undefined') {
                    resolve(true);
                    return;
                }
    
                if (Date.now() - start > maxMs) {
                    resolve(false);
                    return;
                }
    
                setTimeout(tick, intervalMs);
            };
    
            tick();
        });
    }
}
